import { useEffect } from 'react';
import { useLocation } from 'ice';
import { useStore } from '@/store';
import { isWeChat } from '@/utils';
import { ClientHostType } from '@/types';

// 记录路由记录
export default function useRouterHistory() {
    // 获取当前的location对象
    const location = useLocation();
    const { routerHistory, setRouterHistory, channel } = useStore();

    useEffect(() => {
        const newList = [...routerHistory, location.pathname].slice(-3);
        setRouterHistory(newList);
    }, [location]); // 依赖项为location，只有当location变化时才执行


    useEffect(() => {
        if(!!channel && channel !== 'null'){
            if(channel === ClientHostType.galaxy){
                return;
            }
            if (isWeChat()) {
                window.location.href = `${window.location.origin}/film/index.html${window.location.search}`;
            }
        }
    }, [channel]);
}
